import { ButtonType } from "@components/Button/types";
import { ExclusiveLabel } from "@components/ExclusiveLabel";
import { GoalIcon } from "@components/Goals/GoalIcon";
import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Title3, Title4 } from "@components/Typography";
import { TransactionStatus, TransactionType } from "@ctypes";
import { useModal } from "@hooks";
import { i18n, Translations } from "@i18n";
import { EditOneTimeContributionModal } from "@routes/TransfersRoute/TransactionList/EditOneTimeContributionModal";
import { EditRecurringContributionModal } from "@routes/TransfersRoute/TransactionList/EditRecurringContributionModal";
import { Row } from "@routes/VerifiedRoute/styles";
import { convertCentsToDollar, formatCurrency } from "@utils";
import { StepCounter } from "./StepCounter";
import { useStyles } from "./styles";
import { ModalType, UpdateTransferModalProps } from "./types";

export const UpdateTransferModal = ({
  item,
  type = ModalType.Contribution,
}: UpdateTransferModalProps) => {
  const styles = useStyles();

  const { show, dismiss } = useModal();

  const isWithdrawAll = item.type === TransactionType.WithdrawalAll;

  const amount = formatCurrency(convertCentsToDollar(item.amountInCents), true);

  const goalAmountText = isWithdrawAll
    ? i18n.t(Translations.UpdateTransferModalWithdrawAll)
    : amount;

  const onUpdate = () => {
    dismiss();
    if (item.type === TransactionType.OneTimeContribution) {
      show(<EditOneTimeContributionModal item={item} />);
    } else {
      show(<EditRecurringContributionModal item={item} />);
    }
  };

  const props: OverlayProps = {
    cta: {
      ...(item.status === TransactionStatus.Scheduled && {
        primary: {
          title: i18n.t(Translations.UpdateTransferModalPrimaryCTA),
          onClick: onUpdate,
        },
      }),
      secondary: {
        title: i18n.t(Translations.UpdateTransferModalSecondaryCTA),
        type: ButtonType.Secondary,
        onClick: dismiss,
      },
    },
  };

  return (
    <Overlay {...props}>
      <Title3>{item.description}</Title3>
      <Spacing size={SpacingSizes.S} />

      <Row style={styles.row}>
        <GoalIcon type={item.goalType} />
        <Title4 style={styles.goalName}>{item.goalName}</Title4>
      </Row>
      <Spacing size={SpacingSizes.S} />

      {item.goalType && item.goalName ? (
        <>
          <div style={styles.row}>
            <ExclusiveLabel style={styles.exclusive}>{item.beneficiaryName}</ExclusiveLabel>
            <Title4 style={styles.goalLabel}>{goalAmountText}</Title4>
          </div>
          <Spacing size={SpacingSizes.XL} />
        </>
      ) : null}

      <StepCounter item={item} type={type} />
    </Overlay>
  );
};
